import { render, staticRenderFns } from "./InvalidContacts.vue?vue&type=template&id=5722cb52&"
import script from "./InvalidContacts.vue?vue&type=script&lang=js&"
export * from "./InvalidContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports